import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import Layout from '../components/Layout';
import DATMyClaimIFrame from '../components/DATMyClaimIFrame';
import { toast } from 'sonner';

const DATIntegration = ({ user }) => {
  const navigate = useNavigate();
  const [calculationData, setCalculationData] = useState(null);

  const handleCalculationComplete = (data) => {
    setCalculationData(data);
    
    // Show calculation summary
    if (data.totalPrice) {
      toast.success(`Kalkulation abgeschlossen: ${data.totalPrice.toFixed(2)} €`, {
        duration: 5000
      });
    }
  };

  return (
    <Layout user={user}>
      {/* Header with back button */}
      <div className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            data-testid="back-button"
          >
            <ArrowLeft className="w-5 h-5 text-gray-600" />
          </button>
          <div>
            <h1 className="text-xl font-bold text-gray-900">DAT myClaim Integration</h1>
            <p className="text-sm text-gray-500">Direkte Glaskalkulation über DAT</p>
          </div>
        </div>
        
        {calculationData && (
          <div className="bg-green-50 border border-green-200 px-4 py-2 rounded-lg">
            <p className="text-sm font-medium text-green-800">
              Gesamt: {calculationData.totalPrice?.toFixed(2) || '0.00'} €
            </p>
          </div>
        )}
      </div>

      {/* IFrame container */}
      <div className="h-[calc(100vh-73px)] bg-gray-50">
        <DATMyClaimIFrame
          caseId={null}
          onCalculationComplete={handleCalculationComplete}
        />
      </div>

      {/* Calculation data viewer (for debugging) */}
      {calculationData && (
        <div className="fixed bottom-4 right-4 bg-white rounded-lg shadow-lg border border-gray-200 p-4 max-w-md max-h-64 overflow-auto">
          <div className="flex items-center justify-between mb-2">
            <h3 className="font-semibold text-gray-900">Kalkulationsdaten</h3>
            <button
              onClick={() => setCalculationData(null)}
              className="text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>
          </div>
          <pre className="text-xs text-gray-600 overflow-auto">
            {JSON.stringify(calculationData, null, 2)}
          </pre>
        </div>
      )}
    </Layout>
  );
};

export default DATIntegration;
